import api from "@/api/boxes";
//  BOXES ACTION

//  CREATE
const createBox = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .createBox(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

const generateBoxes = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .generateBoxes(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

//  READ
const readBox = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .readBox(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

const readBoxes = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .readBoxes(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

const readBoxesByPartner = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .readBoxesByPartner(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

const readBoxInfo = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .readBoxInfo(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

const readBoxByQR = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .readBoxByQR(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

const readBoxesByQR = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .readBoxesByQR(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

const readNextQrNumber = () =>
  new Promise((resolve, reject) => {
    api
      .readNextQrNumber()
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

//  UPDATE
const updateBox = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .updateBox(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

const changeQRNumber = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .changeQRNumber(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

//  DELETE
const deleteBox = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .deleteBox(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export default {
  createBox,
  generateBoxes,
  readBox,
  readBoxes,
  readBoxesByPartner,
  readBoxInfo,
  readBoxByQR,
  readBoxesByQR,
  readNextQrNumber,
  updateBox,
  changeQRNumber,
  deleteBox
};
